var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52.13px",
    height: "63.48px",
    viewBox: "0 0 52.13 63.48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-1287.950000, -3562.750000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-0.060000, -1.890000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1321.56,3575.83 L1340.14,3575.83 L1340.14,3616.94 L1288.01,3616.94 L1288.01,3609.37 L1332.58,3609.37 L1332.58,3583.39 L1321.56,3583.39 L1321.56,3575.83 Z M1288.01,3575.83 L1302.81,3575.83 L1302.81,3583.39 L1288.01,3583.39 L1288.01,3575.83 Z M1288.01,3628.12 L1288.01,3620.56 L1325.18,3620.56 L1325.18,3628.12 L1288.01,3628.12 Z M1308.22,3602.14 L1315.79,3602.14 L1315.79,3594.57 L1308.22,3594.57 L1308.22,3602.14 Z M1315.79,3564.64 L1315.79,3590.79 L1308.22,3590.79 L1308.22,3564.64 L1315.79,3564.64 Z",
    id: "Path_46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.97b8f4dff8c85b31be8343bfc2efefb1.svg";
export { ForwardRef as ReactComponent };